module.exports = __webpack_public_path__ + "static/media/wepik-export-20230616013843bc0T.f6c19ab2.png";